import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { dark } = theme.palette.secondary;

  return {
    listItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 16,
      padding: "0 16px",
      height: 52,
      "&:nth-child(4n - 1)": {
        background: "#fbfbfb"
      }
    },
    trainerInfoButton: {
      textTransform: "capitalize",
      textDecoration: "underline",
      fontSize: 16,
      color: dark,
      "&:hover": {
        textDecoration: "underline"
      }
    },
    iconButton: {
      padding: 12,
      marginRight: -16
    },
    listItemLabel: {
      marginRight: 12,
      lineHeight: 1
    },
    listItemValue: {
      lineHeight: 1,
      textAlign: "right"
    }
  };
});
